/** @jsx jsx */
import { PageContentNonMemoized } from "gatsby-plugin-hfn-profile/components/PageContentNonMemoized";
import { Box, jsx } from "theme-ui";
import React, { useCallback } from "react";
import LayoutHome from "../layout/LayoutHome";
import { eventCallbackTriggers } from "../templates/wppage";

const pageContent =
  '<gatsby_donation amount="0" btntext="Proceed to Registration" donationid="29"' +
  'projectid="" btnbg="#4d8f15" colortext="black" colorprimary="forestgreen"' +
  'colorsecondary="darkgreen" colorbackground="white" colormuted="#f6f6f6"' +
  'colorhighlight="#efeffe" titletext="General Donation SMSF, EUROPE offline"/>';
const PageContent = React.memo(PageContentNonMemoized);

const SmsfEUROPEOffline = () => {
  const eventCallback = useCallback(
    (event) =>
      eventCallbackTriggers("smsf-europe-general-donation-offline", event),
    []
  );

  return (
    <LayoutHome
      seoTitle="General Donation to SMSF - Europe offline - Donations"
      contentHeaderStyle="contentHeaderText"
      contentHeader={<h3>Heartfulness Donations</h3>}
    >
      <Box>
        <h3 style={{ margin: "10px 0" }}>General Donation to SMSF-Europe</h3>
        <p>
          <b>Welcome!</b> Thank you for choosing to donate to Sahaj Marg
          Spirituality Foundation, Europe.
        </p>
        <p>
          Sahaj Marg Spirituality Foundation supports all the events and
          programs undertaken by <b>heartfulness.</b>
        </p>
        <p>
          On completion of the donation, a confirmation email will be sent to
          you with a completed donation form attached.{" "}
          <b>Please forward this mail back to</b>{" "}
          <a href="mailto:europedonations@heartfulness.org">
            europedonations@heartfulness.org
          </a>{" "}
          along with its attachment as your confirmation of the donation.
        </p>
        <b>There are no refunds for the donations.</b>
        <br />
        <br />
        <PageContent eventCallback={eventCallback} pageContent={pageContent} />
      </Box>
    </LayoutHome>
  );
};

export default SmsfEUROPEOffline;
